import React, {ReactElement} from "react";

import {css} from "/src/utils/utils";

import * as styles from "./search-pagination-link.module.scss";
import translate from "/src/utils/translate";

interface SearchPaginationLinkProps {
  showLink: boolean;
  page: number;
  darkMode?: boolean;
  onClick: () => void;
}

const SearchPaginationLink = (
  props: SearchPaginationLinkProps
): ReactElement | null => {
  const {showLink, page, onClick, darkMode} = props;

  if (!showLink) {
    return null;
  }

  return (
    <button
      type="button"
      tabIndex={0}
      onClick={onClick}
      className={css(
        "h4",
        styles.searchPaginationLink__btn,
        darkMode ? styles.searchPaginationLink__btnDark : ""
      )}
    >
      <span className={styles.searchPaginationLink__visuallyHidden}>
        {translate("page")}
      </span>{" "}
      {page}
    </button>
  );
};

export default SearchPaginationLink;
